import {Paper} from '@mui/material';
import {DataGrid, GridColDef, GridRowModel} from '@mui/x-data-grid';
import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {Venue} from '../../interfaces';

interface Props {
  venues: Venue[];
  height?: number;
  loading?: boolean;
}

const VenuesTable: React.FC<Props> = ({
  venues,
  height = 700,
  loading = false,
}) => {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      width: 90,
      filterable: true,
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 300,
      filterable: true,
    },
    {
      field: 'city',
      headerName: 'City',
      width: 150,
      filterable: true,
    },
    {
      field: 'stateOrProvince',
      headerName: 'State/Province',
      width: 150,
      filterable: true,
    },
    {
      field: 'country',
      headerName: 'Country',
      width: 150,
      filterable: true,
    },
  ];

  const handleRowClick = useCallback(
    (row: GridRowModel) => {
      navigate(`/admin/venues/${row.id}`);
    },
    [navigate],
  );

  return (
    <Paper sx={{height}}>
      <DataGrid
        rows={venues ?? []}
        columns={columns}
        onRowClick={handleRowClick}
        loading={loading}
      />
    </Paper>
  );
};

export default React.memo(VenuesTable);
